export default {
  'Submit': 'Submit',
  'Save': 'Save',
  'enterOTP': 'Επιβεβαιώστε τον αριθμό τηλεφώνου σας',
  'otpSent': 'Ενιαία κωδικός πρόσβασης που αποστέλλεται',
  'login/signup': 'Welcome to OYO',
  'resendCode': 'Resend Code',
  'edit': 'Edit',
  'otpMessage': 'Enter the OTP we have sent via SMS to your mobile number',
  'oyo360WelcomeMessage': 'Καλώς ήλθατε στο OYO',
  'oyo360ResendCode': 'Ξαναστείλε τον κωδικό',
  'oyo360Edit': 'Επεξεργασία',
  'oyo360otpMessage': 'Εισαγάγετε τον κωδικό που έχετε στείλει μέσω SMS στον αριθμό του κινητού σας',
  'buttonActionContinue': 'Να συνεχίσει',
  'chooseLanguage': 'Επιλέξτε μια γλώσσα',
  'currentLanguage': 'ΤΡΈΧΟΥΣΑ ΓΛΏΣΣΑ',
  'otherLanguages': 'ΆΛΛΕΣ ΓΛΏΣΣΕΣ',
  'google': 'Συνεχίστε με την Google',
  'facebook': 'Συνεχίστε με το Facebook',
  'or': 'ή',
  'buttonActionSubmit': 'υποβάλλουν',
  'signingIn': 'Signing In',
  'mobileNumberPlaceholder': 'Εισάγετε τον αριθμό τηλεφώνου',
  'loginSubText': 'Εισαγάγετε τον αριθμό τηλεφώνου σας για να γίνετε εξοχική κατοικία Belvilla σε μόλις 30 λεπτά',
  'welcomeTitle': 'Welcome to OYO',
  'welcomeHeadingForMailLogin': 'Enter the registered email address associated with us',
  'welcomeHeadingForPhoneLogin': 'Enter the registered mobile number associated with us',
  'emailIdLabel': 'Email Id',
  'phoneNumberLabel': 'Phone number',
  'passwordLabel': 'Password',
  'newPasswordLabel': 'New Password',
  'confirmNewPasswordLabel': 'Confirm New Password',
  'emailErrorMessage': 'Please enter the correct email ID',
  'phoneNumberErrorMessage': 'Please enter the correct phone number',
  'passwordErrorMessage': 'Please enter the correct password',
  'confirmPasswordErrorMessage': 'Password is not matched!',
  'generateNewPassword': 'Generate a new password',
  'loginButtonLabel': 'Login',

  'loginWithPhoneButtonLabel': 'Continue with Phone',
  'loginWithOtp': ' Login with OTP instead',
  'loginWithEmailButtonLabel': 'Continue with Email ID',
  'back': 'Back',
  'loginWithOtpTitle': 'Enter verification code',
  'loginWithOtpHeading': 'A 6-digit code was sent to your phone number',

  'listYourProperty': 'List Your Property',
  'listProperty': 'List property',
  'privacyPolicy': ' Privacy policy',
  'termsOfUse': 'Terms of use',
  'privacyFooterText': 'By logging into the account you are agreeing with our {termsOfUse} and {privacyPolicy}',
  'and': 'and',
  'verifyEmail': 'Verify Email Address',
  'verifyMobile': 'Verify Mobile Number',
  'forgotPasswordPhoneSubHeading': 'We will send you a 6-digit code to verify your phone number',
  'forgotPasswordMailSubHeading': 'We will send you a 6-digit code to verify your email ID',
  'newPasswordCondition1': 'Should have both Number & Symbol',
  'newPasswordCondition2': 'Should have atleast 8 characters',
  'newPasswordCondition3': 'Should have both lowercase & uppercase',
  'confirmLogin': 'Confirm & Login',
  'getOTP': 'Get OTP',
  'invalidInput': 'άκυρη είσοδος',
  'passwordResetMessage': 'Password generated successfully',
  'otpErrorMessage': 'Please enter correct OTP',
  'resendOtpSuccessMessage': 'OTP has been resend on your mobile number successfully',
  'InternalServerErrorMessage': 'Internal Server Error',
  'resetPasswordHeading': 'A 6-digit code was sent to your email and phone number',
  'whiteSpace': ' ',
  'secureInformation': 'Μην ανησυχείτε ότι οι πληροφορίες σας είναι ασφαλείς μαζί μας',
  'termsOfService': 'Όροι χρήσης',
  'termsOfServiceFooter': 'Επιλέγοντας Συνέχεια παρακάτω, συμφωνώ με τους ακόλουθους {termsOfService}',
  'notFoundText': 'We couldn\'t find the page',
  'notFoundDescription': 'Either something went wrong or the page doesn\'t exist anymore',
  'goBackFromNotFoundPage': 'Go Back',
  'goBackToOyoOs': 'Go Back to OYO OS',
  'errorNoAssociatedHotels': 'You have no Hotels associated',
  'facingIssue': 'Facing any issue? ',
  'oldLoginViewSwitch': 'Switch to Old view',
  'mobileSearchPlaceholder': 'Αναζήτηση',
};
